<!--
 * A Vue component for showing a zoomin and zoomout button
-->
<template>
    <div>
        <div class="zoombutton" @click="zoomIn()" :title="$t('zoomIn')">
            <a class="zoomin-icon"></a>
        </div>
        <div class="zoombutton" @click="zoomOut()" :title="$t('zoomOut')">
            <a class="zoomout-icon"></a>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'ZoomButtons',
        inheritAttrs: false,

        computed: { ...mapGetters(['getMainMap']) },

        methods: {
            /**
             * Event handler for clicking zoomIn button manually
             * Increase zoomlevel by 1 and stop tracking GPS in map
             */
            zoomIn() {
                const viewPort = { zoom: this.getMainMap.map.getView().getZoom() + 1 };
                this.$store.dispatch('updateViewPortMap', viewPort);
            },

            /**
             * Event handler for clicking zoomOut button manually
             * Decreases zoomlevel by 1 and stop tracking GPS in map
             */
            zoomOut() {
                const viewPort = { zoom: this.getMainMap.map.getView().getZoom() - 1 };
                this.$store.dispatch('updateViewPortMap', viewPort);
            }
        }
    };
</script>

<style scoped>
    .zoombutton {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 30px;
        width: 30px;
        background-color: #007AC9;
        text-align: center;
        font-size: 16pt;
        line-height: normal;
        cursor: pointer;
        margin-bottom: 4px;
    }

    /*-------------------------------------
    max-width : 600px
    ---------------------------------------*/
    @media (max-width : 600px) {
        .zoombutton {
            display: none;
        }
    }
</style>
